import ConditionType from './ConditionType'

const MovingDownCondition: ConditionType = {
  value: 'moving down',
  label: 'Moving Down',
  hasRHS: false,
}

export default MovingDownCondition
